<div class="modal-container confirm-2fa-modal">
    <div class="fadeInDown">
        <form novalidate="" #form="ngForm">
            <div class="modal-header">
                <div class="row">
                    <button type="button" class="close" (click)="dismissModal()">
                        <img src="assets/icons/dismiss-black.svg">
                    </button>
                </div>
                <div class="image-n-text">
                    <h4 class="title-text">{{'Informe o código' | translate}}</h4>
                    <h4 class="separadorCinzaPadrao mt-6"></h4>
                </div>
            </div>
            <div class="modal-body">
                <p *ngIf="fatorSelecionado === 'EMAIL'" class="mfa-text-info">
                    {{'Enviamos um código para o email:' | translate}} {{ identificadorFator }}.
                    {{ 'Digite-o abaixo para continuar.' | translate }}
                    {{'Caso não encontre, verifique a caixa de spam' | translate}}
                </p>

                <p *ngIf="fatorSelecionado === 'SMS'" class="mfa-text-info">
                    {{'Enviamos um código para o número:' | translate}} {{ identificadorFator }}.
                    {{ 'Digite-o abaixo para continuar.' | translate }}
                </p>

                <label>{{ 'Código de verificação' | translate }} <span class="color-red">*</span></label>
                <div class="form-group">
                    <input #inputCode type="text" class="form-control input-formated ph-no-capture" autofocus
                           name="code2FA" ngModel required maxlength="6" autocomplete="off"
                           [(ngModel)]="codigo2FA" (input)="autoValidate(inputCode.value)"
                           (keydown.enter)="validarAcessoCodigo()"
                           [placeholder]="'Digite o código' | translate" [disabled]="isBlockLimitAttempt">
                  <span *ngIf="isCodigoInvalido" id="codeMfaInput" class="invalid2FA">{{  'Código inválido ou expirado' | translate }}</span>
                </div>

                <p>
                    <span *ngIf="!isReenviarCodigo">{{'Reenviar código em ' | translate }} {{ tempoRestante }} {{'segundos' | translate}}</span>
                    <a *ngIf="isReenviarCodigo" class="novo-codigo-2fa" (click)="reenviarCodigo2FA()">{{'2FA_MENSAGEM_NOVO_CÓDIGO' | translate}}</a>
                </p>

                <p *ngIf="temMultiplosFatores">
                    <a class="novo-codigo-2fa" (click)="alterTypeFactor()">{{'Usar outro método de verificação' | translate}}</a>
                </p>
            </div>

            <div class="modal-footer mt-4 pt-3 px-0 novoLayout mx48 mb56 pb-0">
                <button type="button" class="btn btn-raised btn-pri1 mb-0 btn-dss-save"
                        (click)="validarAcessoCodigo()" [disabled]="isButtonDisabled">
                    <span *ngIf="!isValidating">{{'Verificar' | translate}}</span>
                    <span *ngIf="isValidating">{{'Validando...' | translate}}</span>
                </button>
                <button type="button" class="btn btn-raised btn-pri2 ml8i mb-0 btn-dss-default" (click)="dismissModal()">{{'Cancelar'|translate}}</button>
            </div>
        </form>
    </div>
</div>
